<template>
  <div>
    <Header />
    <router-view />
  </div>
</template>

<script>
import Header from "./components/Header.vue";

export default {
  name: "App",
  components: {
    Header,
  },
};
</script>

<style>
:root {
  --dark: #252423;
  --light: #444342;
  --blue: #4095bf;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
@font-face {
  font-family: "RoobertTRIAL-Regular";
  src: url("./fonts/DP_trial_41644/DP_roobert_TRIAL/RoobertTRIAL-Regular.otf")
    format("opentype");
}

body {
  font-family: "RoobertTRIAL-Regular";
  background: var(--dark);
}
</style>
